<template>
<div>
  <v-autocomplete
    chips dense small-chips deletable-chips clearable return-object
    v-model='selected'
    v-bind='attrs'
    :multiple="multiple"
    item-value='id'
    item-text=text
    prepend-icon='replay'
    :search-input.sync='search'
    :label='label'
    :loading='request.loading'
    :persistent-hint='showHint'
    :hint='hintText'
    :items='formattedClients'
    @click:prepend='fetch'
    @click:clear='clear'
    @keypress.enter='fetch' >
  </v-autocomplete>
  <span class='ml-4 pl-2 caption' v-if='formattedClients' >
    {{ $tc('numresults', this.formattedClients.length, {count: this.formattedClients.length}) }}</span>
  <div v-if='withQuickPick && multiple !== true && numClients > 0' >
    <v-subheader class='pl-2 my-0 py-0 overline' >Quick pick</v-subheader>
    <v-chip
      v-for='cli in formattedClients' :key='cli.id'
      @click='setSelected(cli)'
      style='min-width:120px;'
      class='v-chip--x-small' label >
      <v-icon small left v-if='selected && cli && selected.id === cli.id' >check</v-icon>
      {{cli.first_name}} {{cli.last_name}}
    </v-chip>
  </div>
<!-- {{request.result}} -->
<!-- {{clients}} -->
<!-- <v-btn @click='fetch' /> -->
</div>
</template>
<script>
export default {
  name: 'RelationshipPicker',
  props: {
    label: { type: String, default: 'Choose a client' },
    value: { required: false },
    practitionerId: { required: false },
    multiple: { type: Boolean, default: false },
    withQuickPick: { type: Boolean, default: false },
    attrs: { type: Object, required: false, default: () => {} },
    fromDate: { type: String, required: false },
    toDate: { type: String, required: false },
    statuses: { type: Array, required: false, default: () => [] },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      selected: null,
      search: null,
      timeout: null,
      removeClients: [],
      request: {
        resource: 'ag.spaces.relationships',
        result: { results: [] },
        status: 0,
        loading: false
      }
    }
  },
  mounted () {
    if (this.value) {
      this.selected = this.value
    }
    this.fetch()
  },
  watch: {
    selected () {
      this.$emit('input', this.selected)
      this.$emit('selected', this.selected)
    },
    dateRange () {
      this.debounceFetch()
    },
    statusString () {
      this.debounceFetch()
    },
    touch () {
      this.debounceFetch()
    },
    practitionerId () {
      this.debounceFetch()
    },
    requestStatus () {
      this.$emit('count', this.numClients)
    },
    search () {
      this.debounceFetch()
    }
  },
  methods: {
    debounceFetch () {
      console.log('debouncing')
      if (this.timeout) {
        window.clearTimeout(this.timeout)
      }
      this.timeout = window.setTimeout(this.fetch, 1000)
    },
    clear () {
      this.selected = null
      this.search = null
      this.fetch()
    },
    fetch () {
      let params = {
        page_size: 300,
        ordering: 'first_name,last_name'
      }
      if (this.fromDate) {
        params['after_utc'] = this.fromDate
      }
      if (this.toDate) {
        params['before_utc'] = this.toDate
      }
      if (this.statuses && this.statuses.length > 0) {
        params.statuses = this.statuses
      }
      if (this.search) {
        params.search = this.search
      }
      if (this.practitionerId) {
        params.practitioner_id = this.practitionerId
      }
      this.request.params = params
      this.$request('get', this.request)
    },
    setSelected (cli) {
      let isSelected = (cli && this.selected && cli.id === this.selected.id)
      if (isSelected) {
        this.selected = null
      } else {
        this.selected = cli
      }
    }
  },
  computed: {
    requestStatus () {
      return this.request.status
    },
    statusString () {
      if (this.statuses && this.statuses) {
        return this.statuses.join(',')
      }
      return ''
    },
    dateRange () {
      return this.fromDate + ' ' + this.toDate
    },
    clients () {
      return this.getObjectPath(this.request, 'result.results', [])
    },
    numClients () {
      return this.clients.length
    },
    formattedClients () {
      return this.clients.map((rel) => {
        rel.text = `# ${rel.id} ${rel.first_name} ${rel.last_name}`
        return rel
      })
    },
    showHint () {
      if (this.hintText) {
        return true
      }
      return false
    },
    hintText () {
      if (this.fromDate) {
        let txt = `Only showing clients with appointments after ${this.fromDate}`
        if (this.toDate) {
          txt = `Only showing clients with appointments between ${this.fromDate} and ${this.toDate}`
        }
        if (this.statuses && this.statuses.length > 0) {
          txt += ' with a status in ' + this.statuses.join(', ')
        }
        return txt
      }
      return null
    }
  },
  i18n: {
    messages: {
      en: {
        numresults: 'no clients found|{count} client found|{count} clients found'
      },
      es: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// RelationshipPicker.vue?e921ac2a